










import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import HdrLeftNav from "../../components/left-nav.vue";
import SizhenPatients from "./sizhen-patients/sizhen-patients.vue";
@Component({
  components: {
    MainHeader,
    HdrLeftNav,
    SizhenPatients
  }
})
export default class HdrPatientList extends Vue {}
